<template>
  <div class="financiers">
    <v-card>
      <v-card-title>
        Bayiiler
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-if="financiers"
        class="my-data-table"
        :headers="headers"
        :items="financiers"
        :search="search"
        :items-per-page="5"
      >
        <template v-slot:item.active="{ item }">
          <v-btn
            text
            small
            :color="item.active == true ? ' success' : 'error'"
            >{{ item.active == true ? "AKTİF" : "DEAKTİF" }}</v-btn
          >
        </template>
        <template v-slot:item.view="{ item }">
          <v-icon @click="handleRedirect(item._id)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-btn bottom color="pink" dark fab fixed right @click="handleOpenDialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <add-financier />
  </div>
</template>

<script>
import AddFinancier from "./Partials/AddFinancier.vue";
export default {
  name: "financiers",
  components: { AddFinancier },
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", align: "start", value: "_id" },
        { text: "Bayii Adı", value: "name" },
        { text: "Limit", value: "limit" },
        { text: "Aktif", value: "active" },
        { text: "Aksiyonlar", value: "view" },
      ],
    };
  },
  methods: {
    openDialog(item) {
      // //<v-icon @click="openDialog(item)">mdi-delete</v-icon>  // mdi-pencil in alintaydi. kaldirdik simdilik
      this.$swal({
        title: "Bayii Silme Onayı",
        text:
          item._id + " numaralı financiyi silmek istediğinizden emin misiniz?",
        icon: "warning",
        buttons: {
          cancel: "İptal",
          confirm: { text: "Sil", className: "sweet-warning" },
        },
      }).then((confirm) => {
        if (confirm) {
          this.deleteFinancier(item._id);
        }
      });
    },
    handleRedirect(financierId) {
      this.$router.push("/view-financier/" + financierId);
    },
    handleOpenDialog() {
      this.setDialog({ dialogName: "addFinancier", status: true });
    },
  },
  created() {
    this.loadFinanciers();
  },
};
</script>
